import { RootState } from '@atredux/store'
import { IDevice } from '@atredux/slices/deviceSlice'

export const getCurrentDevice = (state: RootState): Partial<IDevice> => state.device._device
export const getDeviceId = (state: RootState): string => state.device._device.deviceId
export const getDeviceInfoPromise = (state: RootState): Promise<Partial<IDevice>> => state.device._deviceInfoPromise
